import {Backbone} from 'Vertebrae';
import {GeneralAvailability} from '../model/generalAvailability';

export const GeneralAvailabilities = Backbone.Collection.extend({
    _name: 'GeneralAvailability',
    model: GeneralAvailability,
});
